import { DataComparator } from '../ListStore';

export function createStringComparator<D>(retriever: (data: D) => string): DataComparator<D>
{
    return (d1, d2) => (retriever(d1) || '').localeCompare((retriever(d2) || ''));
}
